/*
 * Copyright (c) Vaisala Oyj. All rights reserved.
 */

export interface TooltipProps {
  tooltip: string;
  hPos: 'left' | 'center' | 'right';
  vPos: 'top' | 'bottom';
}

export const Tooltip = ({ tooltip, hPos, vPos }: TooltipProps) => (
  <span className={`tooltip-content ${hPos} ${vPos}`} dangerouslySetInnerHTML={{ __html: tooltip }} />
);
